import React from "react";

import InputWithSymbol from "components/InputWithSymbol";

export default function PriceInput({
  disabled,
  style,
  price = 0,
  currency = "$",
  onChange,
  input = "",
}) {
  const styles = style
    ? { textAlign: "right", ...style }
    : input === "Total"
    ? { textAlign: "right" }
    : { textAlign: "center" };

  const changePrice = (e) => {
    const changedPrice = removeCurrency(e.target.value);
    onChange(changedPrice);
  };

  const removeCurrency = (value) => value.replace(currency, "").trim();

  const onBlur = (e) => {
    const changedPrice = removeCurrency(e.target.value);
    const newPrice =
      isNaN(changedPrice) || changedPrice == ""
        ? Number(0).toFixed(2)
        : Number(changedPrice).toFixed(2);
    onChange(newPrice);
  };

  const displayPrice = price || (price !== "" ? Number(0).toFixed(2) : "");
  return (
    <InputWithSymbol
      onChange={changePrice}
      disabled={disabled}
      value={currency + displayPrice}
      styles={styles}
      onBlur={onBlur}
      changeValue={changePrice}
    />
  );
}
